import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DmrlAdvanceFilterComponent } from '../dmrl-advance-filter/dmrl-advance-filter.component';
import { DMRLFilterForm } from '../../../form-model/dmrl-filter-form.model';
import { ApplicationtTextService } from '../../../services/application-text.service';
import { ToastrService } from '../../../services/toastr-service';
import {
  ContainerType,
  DMRLFilter,
  EquipmentGroup,
  EquipmentManufacturer,
  EquipmentOwner,
  EquipmentReeferType,
  Profile,
} from '../../../models/dmrl-filter.model';
import { TagWithOverflowComponent } from '../../../shared-components/tag-with-overflow/tag-with-overflow.component';
import { DmrlService } from '../dmrl.service';
import { catchError, ReplaySubject, takeUntil } from 'rxjs';
import * as XLSX from 'xlsx';
import { DMRLHeader } from '../../../models/dmrl-header.model';
import { WorkOrderSearchTextForm } from '../../../form-model/work-order-search-text.form.model';
type FilterValue = string[] | boolean | string | undefined;
@Component({
  selector: 'app-dmrl-filter',
  imports: [FormsModule, ReactiveFormsModule, RouterModule, DmrlAdvanceFilterComponent, TagWithOverflowComponent],
  templateUrl: './dmrl-filter.component.html',
  styleUrl: './dmrl-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DmrlFilterComponent {
  @Input({ required: true }) filterFormGroup!: FormGroup<{
    dmrlFilterForm: FormGroup<DMRLFilterForm>;
    workOrderSearchTextForm: FormGroup<WorkOrderSearchTextForm>;
  }>;
  showAdvanceFilters: boolean = false;
  taggedFilters: { key: string; value: FilterValue }[] = [];
  savedFilter!: FormGroup<DMRLFilterForm>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  @ViewChild(DmrlAdvanceFilterComponent) advFilter!: DmrlAdvanceFilterComponent;
  downloadData!: any;
  isDownload: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private dmrlService: DmrlService,
    private toastrService: ToastrService,
    private appTextSvc: ApplicationtTextService,
  ) {}
  ngAfterViewInit(): void {
    this.subscribeToFormChanges();
  }

  private subscribeToFormChanges() {
    this.filterFormGroup.controls.dmrlFilterForm?.controls.applyDmrlFilter?.valueChanges.subscribe((value) => {
      if (value) {
        this.showAdvanceFilters = false;
        this.updateSelectedFiltersSection();
      }
    });
    this.filterFormGroup.controls.workOrderSearchTextForm.controls.appliedWOSearchTextFilter?.valueChanges.subscribe((_) => {
      this.updateSelectedFiltersSection();
    });
  }
  updateSelectedFiltersSection() {
    this.markAsTagged('Equipment ID', this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentID.value);
    this.markAsTagged('Location Code', this.filterFormGroup.controls.dmrlFilterForm.controls.locationCode.value);
    this.markAsTagged('Profile', this.filterFormGroup.controls.dmrlFilterForm.controls.profile.value);
    this.markAsTagged('Production Year', this.filterFormGroup.controls.dmrlFilterForm.controls.productionYear.value);
    this.markAsTagged('Equipment Group', this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentGroup.value);
    this.markAsTagged('Equipment Owner', this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentOwner.value);
    this.markAsTagged('Equipment Manufacturer', this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentManufacturer.value);
    this.markAsTagged('Equipment Reefer Type', this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentReeferType.value);
    this.markAsTagged('Container Type', this.filterFormGroup.controls.dmrlFilterForm.controls.containerType.value);
    this.markAsTagged('Is Sales', this.filterFormGroup.controls.dmrlFilterForm.controls.isSales.value);
    this.markAsTagged('Is Surplus', this.filterFormGroup.controls.dmrlFilterForm.controls.isSurplus.value);
    this.markAsTagged('Is Empty', this.filterFormGroup.controls.dmrlFilterForm.controls.isEmpty.value);
    this.updateStatusCountAndTag();
  }
  markAsTagged(key: string, newValue: FilterValue | null) {
    const currentValue = this.getFilterValue(key);
    if (currentValue !== newValue) {
      this.removeFilter(key);
      if (newValue !== null && newValue !== '' && (!Array.isArray(newValue) || newValue.length > 0)) {
        this.taggedFilters.unshift({ key, value: newValue });
      }
    }
  }
  removeFilter(key: string) {
    this.taggedFilters = this.taggedFilters.filter((filter) => filter.key !== key);
  }
  getFilterValue(key: string) {
    const filter = this.taggedFilters.find((filter) => filter.key === key);
    return filter ? filter.value : null;
  }
  private updateStatusCountAndTag() {
    const filters: DMRLFilter = {};
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentID.value) {
      filters.containerNumbers = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentID.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.locationCode.value) {
      filters.locationCodes = this.filterFormGroup.controls.dmrlFilterForm.controls.locationCode.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.productionYear.value) {
      filters.productionYears = this.filterFormGroup.controls.dmrlFilterForm.controls.productionYear.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.profile.value) {
      filters.profiles = this.filterFormGroup.controls.dmrlFilterForm.controls.profile.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentGroup.value) {
      filters.equipmentGroups = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentGroup.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentOwner.value) {
      filters.equipmentOwners = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentOwner.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentManufacturer.value) {
      filters.equipmentManufacturers = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentManufacturer.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentReeferType.value) {
      filters.equipmentReeferTypes = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentReeferType.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.containerType.value) {
      filters.containerTypes = this.filterFormGroup.controls.dmrlFilterForm.controls.containerType.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.isSales.value) {
      filters.isSales = this.filterFormGroup.controls.dmrlFilterForm.controls.isSales.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.isSurplus.value) {
      filters.isSurplus = this.filterFormGroup.controls.dmrlFilterForm.controls.isSurplus.value;
    }
    if (this.filterFormGroup.controls.dmrlFilterForm.controls.isEmpty.value) {
      filters.isEmpty = this.filterFormGroup.controls.dmrlFilterForm.controls.isEmpty.value;
    }
  }
  showAdvanceFiltersModal() {
    this.showAdvanceFilters = true;
    this.saveCurrentFilters();
  }
  private saveCurrentFilters(): void {
    this.savedFilter = this.formBuilder.group({
      equipmentID: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentID.value),
      locationCode: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.locationCode.value),
      profile: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.profile.value),
      productionYear: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.productionYear.value),
      equipmentGroup: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentGroup.value),
      equipmentOwner: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentOwner.value),
      equipmentManufacturer: this.formBuilder.control<string[] | null>(
        this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentManufacturer.value,
      ),
      equipmentReeferType: this.formBuilder.control<string[] | null>(
        this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentReeferType.value,
      ),
      containerType: this.formBuilder.control<string[] | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.containerType.value),
      isSales: this.formBuilder.control<boolean | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.isSales.value),
      isSurplus: this.formBuilder.control<boolean | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.isSurplus.value),
      isEmpty: this.formBuilder.control<boolean | null>(this.filterFormGroup.controls.dmrlFilterForm.controls.isEmpty.value),
      applyDmrlFilter: this.formBuilder.control<boolean | null>(
        this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.value,
      ),
    });
  }
  closeAdvanceFiltersModal() {
    if (this.showAdvanceFilters) {
      this.showAdvanceFilters = false;
      this.filterFormGroup.controls.dmrlFilterForm.reset(this.savedFilter.value);
    }
    this.updateSelectedFiltersSection();
  }
  clearAllSelectedFilters() {
    this.advFilter.clearFilters();
    this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.setValue(true);
    this.updateSelectedFiltersSection();
  }
  closeAdvance() {
    this.updateSelectedFiltersSection();
    this.showAdvanceFilters = false;
  }
  getTaggedFilterValue(taggedFilter: { key: string; value: FilterValue }, itemNumber: number = -1): FilterValue {
    switch (taggedFilter.key) {
      case 'Production Year':
        let productionYear = taggedFilter.value as string[];
        return productionYear[itemNumber];
      case 'Equipment Group':
        let equipmentGroup = taggedFilter.value as EquipmentGroup[];
        return `${equipmentGroup[itemNumber].equipmentGroup}`;
      case 'Equipment Owner':
        let equipmentOwner = taggedFilter.value as EquipmentOwner[];
        return `${equipmentOwner[itemNumber].equipmentOwner}`;
      case 'Equipment Manufacturer':
        let equipmentManufacturer = taggedFilter.value as EquipmentManufacturer[];
        return `${equipmentManufacturer[itemNumber].equipmentManufacturer}`;
      case 'Equipment Reefer Type':
        let equipmentReeferType = taggedFilter.value as EquipmentReeferType[];
        return `${equipmentReeferType[itemNumber].equipmentRefeerType}`;
      case 'Container Type':
        let containerType = taggedFilter.value as ContainerType[];
        return `${containerType[itemNumber].containerType}`;
      case 'Is Sales':
      case 'Is Surplus':
      case 'Is Empty':
        let value = taggedFilter.value as boolean;
        return value ? 'Yes' : 'No';
      default:
        return '';
    }
  }
  getTaggedProductionYear(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Production Year');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }

  getTaggedEquipmentGroup(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Equipment Group');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }
  getTaggedEquipmentOwner(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Equipment Owner');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }
  getTaggedEquipmentManufacturer(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Equipment Manufacturer');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }
  getTaggedEquipmentReeferType(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Equipment Reefer Type');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }
  getTaggedContainerType(): string[] {
    const statusTag = this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Container Type');
    return statusTag && Array.isArray(statusTag.value) ? (statusTag.value as string[]) : [];
  }
  isArrayType(value: FilterValue): boolean {
    return Array.isArray(value);
  }
  getTaggedEquipmentNumbers(): string[] {
    return (this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Equipment ID')?.value as string[]) || [];
  }
  getTaggedLocationCode(): string[] {
    return (this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Location Code')?.value as string[]) || [];
  }
  getTaggedProfiles(): string[] {
    return (this.taggedFilters.find((taggedFilter) => taggedFilter.key === 'Profile')?.value as string[]) || [];
  }
  unselectEquipmentNumber() {
    return (equipmentNumber: string) => {
      let key = this.taggedFilters.find((x) => x.key == 'Equipment ID');
      const equipmentNumberControl = this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentID;
      const currentValues = key?.value as string[];
      const updatedValue = currentValues.filter((eqnumber) => eqnumber != equipmentNumber);
      if (key) {
        key.value = updatedValue;
      }
      equipmentNumberControl.setValue(updatedValue.length ? updatedValue : null);
      this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.setValue(true);
      this.updateSelectedFiltersSection();
    };
  }
  unselectLocationCode() {
    return (locationCode: string) => {
      let key = this.taggedFilters.find((x) => x.key == 'Location Code');
      const locationCodeControl = this.filterFormGroup.controls.dmrlFilterForm.controls.locationCode;
      const currentValues = key?.value as string[];
      const updatedValue = currentValues.filter((locCode) => locCode != locationCode);
      if (key) {
        key.value = updatedValue;
      }
      locationCodeControl.setValue(updatedValue.length ? updatedValue : null);
      this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.setValue(true);
      this.updateSelectedFiltersSection();
    };
  }
  unselectProfile() {
    return (profile: string) => {
      let key = this.taggedFilters.find((x) => x.key == 'Profile');
      const profileControl = this.filterFormGroup.controls.dmrlFilterForm.controls.profile;
      const currentValues = key?.value as string[];
      const updatedValue = currentValues.filter((prof) => prof != profile);
      if (key) {
        key.value = updatedValue;
      }
      profileControl.setValue(updatedValue.length ? updatedValue : null);
      this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.setValue(true);
      this.updateSelectedFiltersSection();
    };
  }
  unselectSpecificFilter(taggedFilter: { key: string; value: FilterValue }, itemNumber: number = -1, itemValue = ''): void {
    switch (taggedFilter.key) {
      case 'Profile':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const updatedProfile: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.profile.setValue(updatedProfile.length ? updatedProfile : null);
        }
        break;
      case 'Production Year':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const updatedProductionYear: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.productionYear.setValue(
            updatedProductionYear.length ? updatedProductionYear : null,
          );
        }
        break;
      case 'Equipment Group':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const equipmentGroup: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentGroup.setValue(equipmentGroup.length ? equipmentGroup : null);
        }
        break;
      case 'Equipment Manufacturer':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const equipmentManufacturer: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentManufacturer.setValue(
            equipmentManufacturer.length ? equipmentManufacturer : null,
          );
        }
        break;
      case 'Equipment Owner':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const equipmentOwner: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentOwner.setValue(equipmentOwner.length ? equipmentOwner : null);
        }
        break;
      case 'Equipment Reefer Type':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const equipmentReeferType: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.equipmentReeferType.setValue(
            equipmentReeferType.length ? equipmentReeferType : null,
          );
        }
        break;
      case 'Container Type':
        if (Array.isArray(taggedFilter.value) && itemNumber >= 0 && itemNumber < taggedFilter.value.length) {
          let profile = taggedFilter.value as string[];
          const containerType: string[] = profile.filter((_: string, index: number) => index !== itemNumber);
          this.filterFormGroup.controls.dmrlFilterForm.controls.containerType.setValue(containerType.length ? containerType : null);
        }
        break;
      case 'Is Sales':
        this.filterFormGroup.controls.dmrlFilterForm.controls.isSales.setValue(null);
        break;
      case 'Is Surplus':
        this.filterFormGroup.controls.dmrlFilterForm.controls.isSurplus.setValue(null);
        break;
      case 'Is Empty':
        this.filterFormGroup.controls.dmrlFilterForm.controls.isEmpty.setValue(null);
        break;
      default:
        break;
    }
    this.filterFormGroup.controls.dmrlFilterForm.controls.applyDmrlFilter.setValue(true);
    this.updateSelectedFiltersSection();
  }

  onDownload() {
    this.isDownload = true;
    let sort = `containerId:asc`;
    if (Object.keys(this.dmrlService.filterData).length > 0) {
      this.dmrlService
        .onDownload(this.dmrlService.filterData, sort)
        .pipe(
          takeUntil(this.destroyed$),
          catchError((err) => {
            this.isDownload = false;
            this.toastrService.showToastr(err.error, 'error');
            throw err;
          }),
        )
        .subscribe((x) => {
          this.isDownload = false;
          this.downloadData = x.body;
          if (this.downloadData) {
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.downloadData.pagedData);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}_${hours}-${minutes}`;
            const fileName = `DMRL_${formattedDate}.xlsx`;
            XLSX.writeFile(wb, fileName);
          }
        });
    }
  }
}
